import type { NotificationData } from '@mantine/notifications';
import { notifications } from '@mantine/notifications';

type PartialNotificationProps = Partial<NotificationData>;

export class TFNotifier {
	static show(props: NotificationData): void {
		if (props?.id) {
			notifications.hide(props.id);
		}

		notifications.show({
			...props,

			styles: {
				root: {
					height: 30,
					padding: '1.5rem .5rem 1.5rem 1.5rem',
				},
			},
		});
	}

	static success(message: string, props?: PartialNotificationProps): void {
		TFNotifier.show({
			message,
			color: 'green',
			...props,
		});
	}

	static error(message: string, props?: PartialNotificationProps): void {
		TFNotifier.show({
			message,
			color: 'red',
			...props,
		});
	}

	static info(message: string, props?: PartialNotificationProps): void {
		TFNotifier.show({
			message,
			color: 'brand',
			...props,
		});
	}
}
